import { useEffect, useMemo, useState } from 'react';
import { useAdminApi } from '../../../lib/adminApi';
import RepeaterEditor from '../components/RepeaterEditor';

const defaults = {
  location: { venue:'', city:'', icon:'lni-map' },
  dates: {
    range: '',
    icon: 'lni-timer',
    days: [{ label:'Samstag', start:'', doors:'' }]
  },
  seats: { label:'', sub:'', icon:'lni-users' },
  extras: { label:'', sub:'', icon:'lni-heart' }
};

export default function CountersEditor(){
  const api = useAdminApi();
  const [doc, setDoc] = useState(defaults);
  const [orig, setOrig] = useState(defaults);
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const dirty = useMemo(()=>JSON.stringify(doc)!==JSON.stringify(orig), [doc,orig]);

  useEffect(()=>{ let alive=true;(async()=>{
    setLoading(true);
    try { const res = await api.get('/sections/counters'); if(!alive) return;
      const merged = { ...defaults, ...(res||{}) }; setDoc(merged); setOrig(merged);
    } finally { setLoading(false); }
  })(); return ()=>{alive=false}; },[]); // eslint-disable-line

  const onSave = async() => {
    setSaving(true); setError('');
    try { await api.put('/sections/counters', doc); setOrig(doc); setEditing(false); }
    catch(e){ setError(e?.message || 'Save failed'); }
    finally{ setSaving(false); }
  };

  if (loading) return <Spinner/>;

  const readOnly = !editing;

  return (
    <div>
      <Toolbar title="Counter-Bereich" editing={editing} setEditing={setEditing} onSave={onSave} onCancel={()=>{setDoc(orig); setEditing(false);}} saving={saving} dirty={dirty}/>
      {error && <div className="alert alert-danger m-3 py-2">{error}</div>}
      <div className="p-3">
        <h6 className="mb-2">Ort</h6>
        <Row>
          <Col><Text label="Veranstaltungsort" value={doc.location.venue} onChange={(v)=>setDoc(d=>({...d, location:{...d.location, venue:v}}))} readOnly={readOnly}/></Col>
          <Col><Text label="Stadt" value={doc.location.city} onChange={(v)=>setDoc(d=>({...d, location:{...d.location, city:v}}))} readOnly={readOnly}/></Col>
          <Col><Text label="Datumsbereich (Text)" value={doc.dates.range} onChange={(v)=>setDoc(d=>({...d, dates:{...d.dates, range:v}}))} readOnly={readOnly}/></Col>
        </Row>

        <RepeaterEditor
          title="Tage"
          items={doc.dates.days}
          onChange={(v)=>setDoc(d=>({...d, dates:{...d.dates, days:v}}))}
          template={{ label:'', start:'', doors:'' }}
          renderFields={(it, patch)=>(
            <Row>
              <Col><Text label="Label" value={it.label} onChange={(v)=>patch({label:v})} readOnly={readOnly}/></Col>
              <Col><Text label="Beginn" value={it.start} onChange={(v)=>patch({start:v})} readOnly={readOnly}/></Col>
              <Col><Text label="Einlass" value={it.doors} onChange={(v)=>patch({doors:v})} readOnly={readOnly}/></Col>
            </Row>
          )}
        />

        <h6 className="mt-3 mb-2">Plätze</h6>
        <Row>
          <Col><Text label="Label" value={doc.seats.label} onChange={(v)=>setDoc(d=>({...d, seats:{...d.seats, label:v}}))} readOnly={readOnly}/></Col>
          <Col><Text label="Untertitel" value={doc.seats.sub} onChange={(v)=>setDoc(d=>({...d, seats:{...d.seats, sub:v}}))} readOnly={readOnly}/></Col>
        </Row>

        <h6 className="mt-3 mb-2">Extras</h6>
        <Row>
          <Col><Text label="Label" value={doc.extras.label} onChange={(v)=>setDoc(d=>({...d, extras:{...d.extras, label:v}}))} readOnly={readOnly}/></Col>
          <Col><Text label="Untertitel" value={doc.extras.sub} onChange={(v)=>setDoc(d=>({...d, extras:{...d.extras, sub:v}}))} readOnly={readOnly}/></Col>
        </Row>
      </div>
    </div>
  );
}
function Toolbar(p){ return CarouselToolbar(p); }
function Spinner(){ return (<div className="p-4 text-center"><div className="spinner-border brand-spinner" role="status" /><div className="small mt-2 text-muted">Lädt…</div></div>); }
const CarouselToolbar = ({ title, editing, setEditing, onSave, onCancel, saving, dirty }) => (
  <div className="editor-toolbar">
    <div className="d-flex align-items-center gap-2">
      <h4 className="editor-title m-0">{title}</h4>
      {editing && dirty && <span className="badge-soft">• Ungespeicherte Änderungen</span>}
    </div>
    <div className="d-flex align-items-center gap-2">
      {!editing ? <button className="btn btn-sm btn-edit" onClick={()=>setEditing(true)}>Bearbeiten</button> : (
        <>
          <button className="btn btn-sm btn-save" onClick={onSave} disabled={!dirty || saving}>{saving ? 'Speichert…' : 'Speichern'}</button>
          <button className="btn btn-sm btn-cancel" onClick={onCancel} disabled={saving}>Abbrechen</button>
        </>
      )}
    </div>
  </div>
);
function Text({label, value, onChange, readOnly}){ return (<div className="mb-3"><label className="form-label">{label}</label><input className="form-control" value={value||''} onChange={e=>onChange(e.target.value)} readOnly={readOnly}/></div>); }
const Row = ({children}) => <div className="row">{children}</div>;
const Col = ({children}) => <div className="col-md-4">{children}</div>;
